import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "star", "input" ]

  connect() {
    this.value = parseInt(this.inputTarget.value, 10) || 0
    this.updateStars(this.value)
  }

  select(event) {
    const index = parseInt(event.currentTarget.dataset.index, 10)
    this.value = index + 1
    this.inputTarget.value = this.value
    this.updateStars(this.value)
    this.dispatch("changed")
  }

  hover(event) {
    const index = parseInt(event.currentTarget.dataset.index, 10)
    this.updateStars(index + 1)
  }

  reset() {
    this.updateStars(this.value)
  }

  updateStars(rating) {
    this.starTargets.forEach((star, index) => {
      if (index < rating) {
        star.classList.remove("text-gray-300")
        star.classList.add("text-amber-400")
      } else {
        star.classList.remove("text-amber-400")
        star.classList.add("text-gray-300")
      }
    })
  }
}
